export default "__VITE_ASSET__DV2V0DTk__"